import Price_Chart from "./Price_Chart";

import Data from "./Data";
import TopHeading from "./TopHeading";

export default function LiveStat() {
  return (
    <div className="m-t-1">
      <div className="container">
        <TopHeading/>

        <div className="d-g g-t-c g-2  t-a-l">
          <div className=" ">
            <Data />
          </div>
          <div className="">
            <Price_Chart />
          </div>
        </div>
        <hr />

     
      </div>
    </div>
  );
}
